import dayjs from "./dayjs";

// Utility to format epoch ms to MM/DD/YY (UTC)
export const formatEpochToDateString = (epoch: string | number) => {
  if (epoch == null || isNaN(Number(epoch))) return "";
  return dayjs.utc(epoch).format("MM/DD/YY");
};

export const formatEpochToDate = (epoch: string | number) => {
  if (epoch == null || isNaN(Number(epoch))) return "";
  return dayjs.utc(epoch);
};

export const shortFormatDateString = (date: Date | dayjs.Dayjs) => {
  return dayjs.utc(date).format("MM/DD/YY");
};
